import { ComponentConfig } from './shared';
import HotTournamentsCarousel from '@modules/sportOffer/hotTournaments/HotTournamentsCarousel.vue';
import PopularSuperbetsCarousel from '@modules/sportOffer/popularSuperbets/PopularSuperbetsCarousel.vue';
import HomeInPlay from '@modules/sportOffer/sharedSubmodules/HomeInPlay.vue';
import SportOfferCarousel from '@modules/sportOffer/sharedSubmodules/SportOfferCarousel.vue';
import Survey from '@modules/survey/Survey.vue';
import PromotionsBannerContainer from '@shared/banners/PromotionsBannerContainer.vue';
import QuickLinksContainer from '@shared/banners/QuickLinksContainer.vue';
import MEBBBanner from '@sportOfferFederation/bet-builder/multi-event/components/MEBBBanner.vue';
import SeoCopyBlockWrapper from '@src/app/seo/SeoCopyBlockWrapper.vue';
import PriceBoostCarousel from '@src/federations/sportOffer/price-boost/components/PriceBoostCarousel.vue';
import PE92InlineDepositForm from '@walletFederation/src/components/PE92InlineDepositForm.vue';
import { PortalTarget } from 'portal-vue';

export const HomeComponent = {
    BANNERS: 'BANNERS',
    QUICK_LINKS: 'QUICK_LINKS',
    INLINE_DEPOSIT_FORM: 'INLINE_DEPOSIT_FORM',
    ONBOARDING_CHALLENGE_TRACKER: 'ONBOARDING_CHALLENGE_TRACKER',
    TOP_TEN: 'TOP_TEN',
    TOP_PRICE_BOOST: 'TOP_PRICE_BOOST',
    TOP_LIVE: 'TOP_LIVE',
    SOCIAL_VIDEOS: 'SOCIAL_VIDEOS',
    POPULAR_SUPERBETS: 'POPULAR_SUPERBETS',
    HOT_TOURNAMENTS: 'HOT_TOURNAMENTS',
    SUPER_COTA: 'SUPER_COTA',
    SOCIAL_DISCOVER_TICKETS: 'SOCIAL_DISCOVER_TICKETS',
    CASINO_GAMES: 'CASINO_GAMES',
    MEBB_BANNER: 'MEBB_BANNER',
    HOME_LIVE: 'HOME_LIVE',
    SOCIAL_APP_BANNER: 'SOCIAL_APP_BANNER',
    SUPER_EXTRA: 'SUPER_EXTRA',
    SURVEY: 'SURVEY',
    SOCIAL_NEWS: 'SOCIAL_NEWS',
    SOCIAL_EXPLORE_FEED: 'SOCIAL_EXPLORE_FEED',
    SEO_COPY: 'SEO_COPY',
    CASINO_POPUP: 'CASINO_POPUP',
} as const;

export type HomeComponentKey = keyof typeof HomeComponent;

export type HomeComponentMap = {
    [HomeComponent.BANNERS]: ComponentConfig<typeof PromotionsBannerContainer>;
    [HomeComponent.QUICK_LINKS]: ComponentConfig<typeof QuickLinksContainer>;
    [HomeComponent.INLINE_DEPOSIT_FORM]: ComponentConfig<typeof PE92InlineDepositForm>;
    [HomeComponent.ONBOARDING_CHALLENGE_TRACKER]: ComponentConfig<'PE123OnboardingChallengeTracker'>;
    [HomeComponent.TOP_TEN]: ComponentConfig<typeof SportOfferCarousel>;
    [HomeComponent.TOP_LIVE]: ComponentConfig<typeof SportOfferCarousel>;
    [HomeComponent.TOP_PRICE_BOOST]: ComponentConfig<typeof PriceBoostCarousel>;
    [HomeComponent.SOCIAL_VIDEOS]: ComponentConfig<'SocialVideoThumbnails'>;
    [HomeComponent.POPULAR_SUPERBETS]: ComponentConfig<typeof PopularSuperbetsCarousel>;
    [HomeComponent.HOT_TOURNAMENTS]: ComponentConfig<typeof HotTournamentsCarousel>;
    [HomeComponent.SUPER_COTA]: ComponentConfig<typeof SportOfferCarousel>;
    [HomeComponent.SOCIAL_DISCOVER_TICKETS]: ComponentConfig<'SocialDiscoverTickets'>;
    [HomeComponent.CASINO_GAMES]: ComponentConfig<'GamingEmbeddableSection'>;
    [HomeComponent.MEBB_BANNER]: ComponentConfig<typeof MEBBBanner>;
    [HomeComponent.HOME_LIVE]: ComponentConfig<typeof HomeInPlay>;
    [HomeComponent.SOCIAL_APP_BANNER]: ComponentConfig<'SocialAppBannerHome'>;
    [HomeComponent.SUPER_EXTRA]: ComponentConfig<typeof SportOfferCarousel>;
    [HomeComponent.SOCIAL_NEWS]: ComponentConfig<'SocialNewsCarousel'>;
    [HomeComponent.SOCIAL_EXPLORE_FEED]: ComponentConfig<'SocialExploreFeed'>;
    [HomeComponent.SURVEY]: ComponentConfig<typeof Survey>;
    [HomeComponent.SEO_COPY]: ComponentConfig<typeof SeoCopyBlockWrapper>;
    [HomeComponent.CASINO_POPUP]: ComponentConfig<typeof PortalTarget>;
};
